import { useRef as c, useEffect as i } from "react";
const f = (s) => {
  const { ref: r } = s, e = c(void 0);
  e.current = s.onResize, i(() => {
    if (!r.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const n = new ResizeObserver((o) => {
      var t;
      (t = e.current) == null || t.call(e, o, n);
    });
    return n.observe(r.current), () => {
      n.disconnect();
    };
  }, [r]);
};
export {
  f as useResizeObserver
};
